
import { RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';

export const admin: Routes = [
    {
        path: 'validate-users',
        loadComponent: () =>
            import('../../admin/users-validation/users-validation.component')
                .then((m) => m.AdminUserValidationComponent),
    }
]
@NgModule({
    imports: [RouterModule.forRoot(admin, {
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'top',
      })],
    exports: [RouterModule]
})
export class AdminRoutingModule { }
